export const INVITEE_CATEGORY = 'PLR - COMPLEMENTO';

export const LEAD_OFFER_PAGE = 'OFERTA COMPLEMENTO';
export const LEAD_PICKER_PAGE = 'ELEGIR RELACION COMPLEMENTO';
export const LEAD_SHARE_PAGE = 'COMPARTIR ENLACE';

export const INVITEE_WELCOME_PAGE = 'INVITACION';
export const INVITEE_DEAD_LINK_PAGE = 'INVITACION ENLACE MUERTO';
export const INVITEE_RATE_LIMIT_PAGE = 'INVITACION LIMITE CONSULTAS';

export const INVITEE_ACCEPTED_PAGE = 'COMPLEMENTO ACEPTADO';
export const INVITEE_REJECTED_PAGE = 'COMPLEMENTO RECHAZADO';
export const INVITEE_ALREADY_EVALUATED_PAGE = 'COMPLEMENTO YA EVALUADO';

export const leadResultCategory = (isRedirect?: string | false) => (
  isRedirect ? `PLR - ${isRedirect}` : 'PLR - RESULTADO'
);

export const inviteePlrCategory = (
  complementToken: string | null | undefined,
  defaultCategory: string,
) => (complementToken ? INVITEE_CATEGORY : defaultCategory);
